import { useTopUserData } from '../Top/TopUserData/useTopUserData'

export function ADM() {
  const { adm } = useTopUserData()

  if (adm === 'administrador') {
    window.location.href = '/administrador'
  }
  return <div />
}
